import cn from 'classnames'
import { forwardRef } from 'react'

import { testPropsEl } from 'utils/test/qaData'

import * as s from './BrandButton.module.scss'

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  styleType?: 'primary' | 'secondary'
  name?: string
}

const BrandButton = forwardRef<HTMLButtonElement, IProps>(
  ({ styleType = 'primary', className, type = 'button', name, children, ...rest }, ref) => (
    <button
      className={cn(s.root, className, { [s.secondary]: styleType === 'secondary' })}
      ref={ref}
      type={type}
      {...rest}
      {...(name ? testPropsEl('button', { name }) : {})}
    >
      {children}
    </button>
  ),
)

BrandButton.displayName = 'BrandButton'

export default BrandButton
